import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Tabs,
  Tab,
  Box,
  Paper
} from '@mui/material';
import Dashboard from '../components/admin/Dashboard';
import SoftwareManager from '../components/admin/SoftwareManager';
import Statistics from '../components/admin/Statistics';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const AdminPanel = () => {
  const { user, isAuthenticated } = useAuth();
  const [tabValue, setTabValue] = useState(0);

  // Verificar permisos de administrador
  if (!isAuthenticated || user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom>
        Panel de Administración
      </Typography>

      <Paper elevation={3}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="admin panel tabs"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="Dashboard" />
          <Tab label="Gestión de Software" />
          <Tab label="Estadísticas" />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <Dashboard />
        </TabPanel>
        
        <TabPanel value={tabValue} index={1}>
          <SoftwareManager />
        </TabPanel>
        
        <TabPanel value={tabValue} index={2}>
          <Statistics />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default AdminPanel;